export function toLocalInputValue(date: Date) {
  const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - offsetMs).toISOString().slice(0, 16);
}

export function fromLocalInputValue(value: string) {
  return new Date(value).toISOString();
}

export function addHoursToLocalInput(value: string, hours: number) {
  return toLocalInputValue(new Date(new Date(value).getTime() + hours * 60 * 60 * 1000));
}

export function getDefaultValidityWindow() {
  const now = new Date();
  const start = new Date(now.getTime() + 5 * 60 * 1000);
  start.setSeconds(0, 0);
  const end = new Date(start.getTime() + 3 * 60 * 60 * 1000);

  return {
    validFromLocal: toLocalInputValue(start),
    validToLocal: toLocalInputValue(end),
  };
}

function formatUtcStamp(value?: string | null) {
  if (!value) {
    return null;
  }

  return `${new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(value)).replace(',', '')}Z`;
}

export function formatUtcRange(validFromUtc?: string | null, validToUtc?: string | null) {
  const start = formatUtcStamp(validFromUtc);
  const end = formatUtcStamp(validToUtc);

  if (!start && !end) {
    return null;
  }

  if (start && end) {
    return `${start} to ${end}`;
  }

  return start || end;
}

export function formatLocalRange(validFromUtc?: string | null, validToUtc?: string | null) {
  if (!validFromUtc && !validToUtc) {
    return null;
  }

  const formatter = new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });

  const start = validFromUtc ? formatter.format(new Date(validFromUtc)) : null;
  const end = validToUtc ? formatter.format(new Date(validToUtc)) : null;

  if (start && end) {
    return `${start} to ${end}`;
  }

  return start || end;
}

export function formatLocalTimestamp(value?: string | null) {
  if (!value) {
    return null;
  }

  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(new Date(value));
}